<template>
  <div id="loader">
    <img src="~/assets/images/Spinner.gif" alt="Loader" class="loader-icon" />
  </div>
</template>


<script>
  export default {
  }
</script>

<style scoped>
  #loader {
    position: fixed;
    height: 100%;
    width: 100%;
    background: rgba(255, 255, 255, 0.9);
    top: 0;
    left: 0;
    z-index: 999999;
  }

  .loader-icon {
    position: absolute;
    top: 50%;
    left: 45%;
    width: 100px;
  }

</style>
